import { useEffect } from 'react';
import { useSession, useSupabaseClient } from '@supabase/auth-helpers-react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserRoles } from '../api/supabaseAPI';

const useUserRoles = () => {
  const session = useSession();
  const supabase = useSupabaseClient();
  const queryClient = useQueryClient();
  const userId = session?.user?.id;

  // Realtime subscription for tutor status changes
  useEffect(() => {
    if (!userId) return;

    const channel = supabase
      .channel(`user-roles-${userId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'tutors_profile',
          filter: `uid=eq.${userId}`
        },
        () => {
          // When tutor status changes, refetch roles
          queryClient.invalidateQueries({ queryKey: ['userRoles', userId] });
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'tutor_applications',
          filter: `uid=eq.${userId}`
        },
        () => {
          // When application status changes, refetch roles
          queryClient.invalidateQueries({ queryKey: ['userRoles', userId] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId, supabase, queryClient]);

  return useQuery({
    queryKey: ['userRoles', userId],
    queryFn: () => getUserRoles(userId),
    enabled: !!userId,
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60,
  });
};

export default useUserRoles;
